import { t } from '@lingui/macro'
import { useNavigate } from 'react-router-dom'

import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { CareQuestionDetailContentLayout } from '../../components/care-question-detail-content-layout/CareQuestionDetailContentLayout'
import { EmergencyCareContent } from './EmergencyCareContent'

export const EmergencyPage = () => {
  const navigate = useNavigate()

  // Hide navigation on native devices
  useHideNativeNavigation()
  const handleClose = () => {
    navigate(-1)
  }

  return (
    <CareQuestionDetailContentLayout
      onClose={handleClose}
      header={{
        secondaryAction: {
          label: t({ id: 'globals.close', message: 'Sluiten' }),
          icon: ['fal', 'times'],
          onClick: handleClose,
        },
      }}
    >
      <EmergencyCareContent />
    </CareQuestionDetailContentLayout>
  )
}
